export default "__VITE_ASSET__D_q05cBp__"